import { CommonNodeIconService } from "./default-impl/node-icon.service";

/**
 * 导航树相关数据服务的默认实现
 * @remarks 当前仅有导航树图标服务具有默认的实现，应当尽量让用户自己传入各种配置
 */
export const DEFAULT_NAV_PANEL_SERVICES = [
  // 导航树数据及图标服务
  CommonNodeIconService
];
